export default function NumberInputDirective() {
  return {
    template: require('./number.component.html'),
    transclude: true,
    restrict: 'AE',
    scope: {
      value: '=ngModel',
      type: '=',
      form: '=',
      hasError: '=',
      min: '=',
      max: '=',
      onSave: '=',
      onChange: '=',
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: function () {
      let vm = this;
      vm.round = round;
      vm.$onInit = () => {
        vm.onSave.invoke = function () {};
      };

      function round() {
        vm.value = Math.round(vm.value);
      }
    },
  };
}
